import React from "react";

type containerType = {
    flex?: boolean;
    children?: any;
    classes?: Array<string>;
}
const Container = ({ flex=true, children, classes}:containerType) => {

    return (
        <div className={`${flex ? 'flex' : 'block'} w-full min-h-screen ${classes && classes.join(' ')}`}>
            {children}
        </div>
    )

}

export default Container;